import { NgModule } from '@angular/core';
import { CommonModule } from '@nano/common';
import { NzListModule } from 'ng-zorro-antd/list';

import { SendMessageComponent } from './send-message.component';

@NgModule({
  imports: [CommonModule, NzListModule],
  declarations: [SendMessageComponent],
  exports: [SendMessageComponent]
})
export class SendMessageModule {}
